// For full API documentation, including code examples, visit https://wix.to/94BuAAs

	//TODO: write your page related code here...

import wixLocation from 'wix-location'; 
import wixWindow from 'wix-window';
$w.onReady(function () {
setTimeout(function() {
wixLocation.to('http://www.wildsolutions.lu/wildsolutions');  //wixLocation.to('https://bob3866.wixsite.com/wildsolutions/wildsolutions'); 
}, 2700);

});